import { useEffect } from 'react'

import { useSearchParams } from 'react-router-dom'
import { useAppInfo } from 'hooks/useAppInfo'
import { useGetAccountInfo, useGetAccountInfoAR } from 'services/account-info/useAccountInfo'

import { interWbSession } from '@interco/inter-webview-bridge'

import { AccountInfoUS } from './AccountInfoUS'
import { AccountInfoAR } from './AccountInfoAR'
import { AccountInfoSkeleton } from './AccountInfoSkeleton'
import { AccountInfoError } from './AccountInfoError'
import { AccountInfoErrorBoundary } from './AccountInfoErrorBoundary'

const AccountInfoContent = () => {
  const [searchParams] = useSearchParams()
  const { language } = useAppInfo()

  useEffect(() => {
    interWbSession.requestAnalytics('DADOS_BANCARIOS_GA_FLUXO', {
      flow: 'dados-bancarios',
      screen: 'dados-bancarios',
      product: 'global-account',
      action_id: 'view',
      lang: language,
    })
  }, [language])

  const account = searchParams.get('account') ?? ''
  const isAR = account.includes('AR')

  const {
    data: accountInfoUS,
    error: errorUS,
    isFetching: isFetchingUS,
    refetch: refetchUS,
  } = useGetAccountInfo({
    enabled: account === 'GA',
  })

  const {
    data: accountInfoAR,
    error: errorAR,
    isFetching: isFetchingAR,
    refetch: refetchAR,
  } = useGetAccountInfoAR(account, language, {
    enabled: account === 'GA' && !!errorUS,
  })

  if (account === 'GA') {
    if (accountInfoUS && !errorUS) {
      return <AccountInfoUS />
    }

    if (errorUS && accountInfoAR && !errorAR) {
      return <AccountInfoAR language={language} account={account} />
    }

    if (isFetchingUS || isFetchingAR) {
      return <AccountInfoSkeleton />
    }

    if (errorUS && errorAR) {
      return (
        <AccountInfoError
          refetch={() => {
            refetchUS()
            refetchAR()
          }}
        />
      )
    }

    return <AccountInfoSkeleton />
  }

  return isAR ? <AccountInfoAR language={language} account={account} /> : <AccountInfoUS />
}

export const AccountInfo = () => (
  <AccountInfoErrorBoundary>
    <AccountInfoContent />
  </AccountInfoErrorBoundary>
)
